import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

export const getShoppingCartRules = async () => {
  setBackendDomain(jwtAuthAxios);
  try {
    const { data } = await jwtAuthAxios.get(`/api/v1/shopping-cart-rules`);
    return data?.rules || [];
  } catch (error) {
    return [];
  }
};

export const updateShoppingCartRule = async (rule) => {
  setBackendDomain(jwtAuthAxios);
  try {
    const { data } = await jwtAuthAxios.put(
      `/api/v1/shopping-cart-rules/${rule._id}`,
      rule
    );
    return data?.rule || {};
  } catch (error) {
    return {};
  }
};

export const deleteShoppingCartRule = async (ruleId) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.delete(
    `/api/v1/shopping-cart-rules/${ruleId}`
  );
  return data?.rule;
};

export const createShoppingCartRule = async (rule) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(`/api/v1/shopping-cart-rules`, rule);
  return data?.rule;
};
export const updateShoppingCartRules = async (rules) => {
  setBackendDomain(jwtAuthAxios);
  try {
    const { data } = await jwtAuthAxios.put(
      `/api/v1/shopping-cart-rules-update`,
      {
        rules,
      }
    );
    return data?.rules || [];
  } catch (error) {
    return {};
  }
};
